import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import Hero from "./components/hero";
import TriCards from "./components/triCards";
import BeforeAfter from "./components/beforeAfter";
import PageShell from "../components/pageShell"
import ZigZag from "./components/zigzag";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const ParkingLotPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Parking Lot Cleaning - Flyby Shine</title>
                        <meta name="description" content="Clean and maintain your parking lot with our personalized cleaning solutions. Our trained professionals have extensive experience in parking lot cleaning and are committed to delivering reliable, high-quality service." />
                        <meta name="keywords" content="Parking Lot Cleaning, Parking lot cleaning services, commercial parking lot cleaning, industrial parking lot cleaning, hygienic parking lot cleaning, expert parking lot cleaning services, safe parking lot cleaning, thorough parking lot cleaning, professional parking lot cleaning, reliable parking lot cleaning, top-quality parking lot cleaning, parking lot cleaning services, parking lot cleaning solutions, parking lot cleaning experts" />
                        <meta property="og:image" content="/assets/parkinglot.png" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Commercial & Industrial'}
                    title={'Parking Lot Cleaning'}
                    description={'Clean and Maintain Your Parking Lot with Our Personalized Cleaning Solutions'}
                    banner={{ image: '/assets/parkinglot.png', alt: 'A clean parking lot' }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/commercial-industrial'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Experienced Team'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'Check Mark' }}
                        description={'Our trained professionals have extensive experience in parking lot cleaning and are committed to delivering reliable, high-quality service.'}

                    />
                    <TriCards.Card
                        title={'High-Quality Equipment'}
                        heading={{ image: '/assets/equipment.svg', alt: 'equipment icon' }}
                        description={'We utilize industrial-grade sweepers and pressure washers to remove all debris, dirt, and spills, ensuring that your parking lot remains spotless and inviting.'}
                    />
                    <TriCards.Card
                        title={'Preventative Maintenance'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'about' }}
                        description={'Regular cleaning helps to prevent deterioration caused by dirt, chemicals, and weather. '}
                    />
                </TriCards>
                <BeforeAfter
                    title={"Before And After"}
                    description={"Keep your parking lot clean and inviting with our personalized cleaning solutions."}
                    subTitle={"Parking Lot Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>
                                    Accepetionally Clean
                                </li>
                                <li><i className="material-icons">check_circle_outline</i>
                                    Industrial Grade Equipment
                                </li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/parkingLotBefore.png',
                        },
                        secondImage: {
                            imageUrl: '/assets/parkingLotAfter.png',
                        }

                    }
                    ]}

                />



                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/parkinglot2.png', alt: 'nationwide about us image' }}
                        title={'Powerful Stain Removal'}

                        description={'Our powerful cleaning methods target tough oil stains, gum, and other persistent marks that can detract from your lots appearance. We leave your surfaces looking clean and professional.'}
                    />

                </ZigZag>
                <Contact />
            </PageShell>


            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }
                    `
                }
            </style>

        </>
    )
}

export default ParkingLotPage
